var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restore-pass"},[_c('auth-form-title',{attrs:{"title-text":_vm.titleText}}),_vm._v(" "),_c('div',{staticClass:"restore-pass__content-wrapper"},[_c('restore-pass')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }